import { call, put } from 'redux-saga/effects';
import { alertPush, sendError } from '../../../';
import { ChangeForgotPasswordFetch, changeForgotPasswordSuccess, forgotPasswordError } from '../actions';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';

export function* changeForgotPasswordSaga(action: ChangeForgotPasswordFetch) {
    try {
        const { new_password, confirm_password } = action.payload;
        const newPasswordConfirm = new_password === confirm_password ? new_password : '';
        const payloadReset = {
            resetToken: action.payload.reset_password_token,
            newPassword: newPasswordConfirm,
        };
        yield call(() => api.post(`${appUrls.authenURL}/reset-password`, payloadReset));
        yield put(changeForgotPasswordSuccess());
        yield put(
            alertPush({
                message: [
                    'Password Changed Successfully',
                    'Your password has been updated. You can now log in with your new password.',
                ],
                type: 'success',
            }),
        );
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: forgotPasswordError,
                },
            }),
        );
    }
}
